;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .controller('DeskfyHeaderController', DeskfyHeaderController)

  /* @ngInject */
  function DeskfyHeaderController ($scope, $rootScope, $state, $q, $timeout, ModalService, UserService, SegmentService, Utils, CONSTANTS, CompanyService) {
    const getChangeCompanyDialogController = () => $q.when(import('../../dialogs/change-company/change-company-dialog.controller'))

    const api = {
      getChangeCompanyDialogController,
      _successGetPreviewsCompanies,
      _handleSuccessUpdateCompany,
      _goToSettingsPage,
      _shouldShowSettingsBtn
    }
    this.getApi = () => api

    activate()

    function activate () {
      if ($rootScope.isDesktop) {
        UserService.getUserCompanies(4, 0, { sort: true, active: true }).then(api._successGetPreviewsCompanies)
      }
      $rootScope.getUser().then(user => {
        $scope.showCompanies = !user.email.includes('deskfy.io')
      })

      $rootScope.getCompanyFeaturesAndAddons().then(({ features }) => {
        $scope.features = features
      })
    }

    function _successGetPreviewsCompanies (res) {
      $scope.previewsCompanies = res.companies
      $scope.allCompaniesCount = res.count
    }

    function _handleSuccessUpdateCompany () {
      CompanyService.reloadWithNewCompany()
    }

    function _goToSettingsPage () {
      if ($rootScope.isUserSysAdminAdmin()) {
        $state.go('admin.general')
      } else {
        if ($scope.features['ARTS.ACCESS']) {
          $state.go('admin.products')
        } else if ($scope.features['POSTS.ACCESS']) {
          $state.go('admin.postCategories')
        }
      }
    }

    function _shouldShowSettingsBtn () {
      return $rootScope.isUserSysAdminAdmin() ||
        ($rootScope.oUserCompanyConfigurations &&
        !$rootScope.isUser() &&
        $scope.features &&
        ($scope.features['ARTS.ACCESS'] || $scope.features['POSTS.ACCESS']))
    }

    $scope.getLogoUrl = function (company) {
      return Utils.fnReplaceStringParams(CONSTANTS.URL_CUSTOMER_COMPANY_LOGO_COLORED, [company.customerCompanyId])
    }

    $scope.changeUserCompany = function (customerCompanyId) {
      UserService.updateUserCompany(customerCompanyId).then(api._handleSuccessUpdateCompany)
    }

    $scope.shouldShowSettingsBtn = api._shouldShowSettingsBtn

    $scope.goToSettings = api._goToSettingsPage

    $scope.openSidebarMenu = function () {
      $('.sidebar-menu').transition('slide right')
      UserService.getUserCompanies(5, 0, { sort: true, active: true }).then(companies => {
        $scope.$emit('mobile.load-previews-companies', companies)
      })
    }

    $scope.getImageProfile = UserService.getUserProfileImage.bind(UserService)

    $scope.handleLogoClick = function () {
      $state.go('home')
    }

    $scope.openDeskfyPage = function () {
      window.open('https://deskfy.io/', '_blank')
    }

    $scope.addIntercomEvent = function () {
      SegmentService.track('create-environment-click')
    }

    $scope.openChangeCompanyDialog = function () {
      api.getChangeCompanyDialogController().then(({ ChangeCompanyDialogController }) => {
        ModalService.showModal({
          templateId: 'changeCompany.html',
          templateUrl: '/core/dialogs/change-company/change-company-dialog.html?$$REVISION$$',
          destroyable: true,
          observeChanges: true,
          controller: ChangeCompanyDialogController
        })
      })
    }
  }
})()
